import * as React from 'react';
import {Badge, Button, Col, Row} from 'reactstrap';
import Panel from '../../../theme/components/Panel';
import Table from '../../../theme/components/table/Table';
import DownloadIcon from 'mdi-react/DownloadIcon';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {localNumber} from '../../../utils/number-utils';

interface RechazosTableProps {
    stockList: mirana.IUIStock[];
    fechaCarga?: string;
    handleGenerarExcel: () => {};
}

class RechazosTable extends React.PureComponent<RechazosTableProps> {

    private badgeColor(monto: number | undefined | null): string {
        if(monto){
            if (monto < 2) {
                return 'error';
            } else if (monto < 6) {
                return 'warning';
            } else {
                return 'success';
            }
        }
        return '';
    }

    private get resumen() {
        return <Row>
            <Col md={3} lg={3}>
                <h4 className='bold-text' style={{textAlign: 'center'}}>
                    <strong>Fecha: {this.props.fechaCarga}</strong>
                </h4>
            </Col>
            <Col md={{size: 1, offset: 8}} lg={{size: 1, offset: 8}}>
                <Button outline={true} className='icon icon--only' onClick={this.props.handleGenerarExcel}
                        disabled={this.props.stockList.length <= 0}><DownloadIcon/></Button>
            </Col>
        </Row>;
    }

    private get filas() {
        const content: any[] = [];
        this.props.stockList.forEach((stock, index) => {
            content.push((
                <tr key={`stock-${index}`}>
                    <td>{stock.categoria}</td>
                    <td>{stock.linea}</td>
                    <td>{stock.marca}</td>
                    <td style={{textAlign: 'right'}}>{localNumber(stock.stock)}</td>
                    <td style={{textAlign: 'right'}}>{localNumber(stock.volumen)}</td>
                    <td style={{textAlign: 'right'}}>{localNumber(stock.promedioDiario)}</td>
                    <td style={{textAlign: 'center'}}>
                        <Badge
                            color={this.badgeColor(stock.diasStock)}>{localNumber(stock.diasStock)}</Badge>
                    </td>
                </tr>));
        });
        return content;
    }

    public render() {
        return (
            <Panel xs={12} md={12} divider={true} title='Resultados'>
                {this.resumen}
                {this.props.stockList.length > 0 ? <Table striped={true} responsive={true}>
                    <thead>
                    <tr>
                        <th>Categor&iacute;a</th>
                        <th>L&iacute;nea</th>
                        <th>Producto</th>
                        <th>Stock Final</th>
                        <th>Venta Secundaria</th>
                        <th>Prom. D&iacute;a</th>
                        <th>D&iacute;as Stock</th>
                    </tr>
                    </thead>
                    <tbody>
                    {this.filas}
                    </tbody>
                </Table> : null}
            </Panel>
        )
    }
}

export default RechazosTable;



// WEBPACK FOOTER //
// ./src/components/pages/stock/stock-table.tsx